function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { IhamburgerMenu, Iclose } from '../AgroIcon/icons';
var AgroHamburgerButton = withCssProps(function (_ref) {
  var _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _onClick = _ref.onClick,
    notifications = _ref.notifications;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showGreenDot = _useState2[0],
    setShowGreenDot = _useState2[1];
  var hasNotifications = function hasNotifications(notifications) {
    notifications.ReceivedUnread && notifications.ReceivedUnread.count > 0 && setShowGreenDot(true);
    notifications.Sent && notifications.Sent.count > 0 && setShowGreenDot(true);
    notifications.SELLER_PENDINGRESPONSE && notifications.SELLER_PENDINGRESPONSE.count > 0 && setShowGreenDot(true);
    notifications.SELLER_PENDINGPAYMENT && notifications.SELLER_PENDINGPAYMENT.count > 0 && setShowGreenDot(true);
    notifications.SELLER_PENDINGDELIVERY && notifications.SELLER_PENDINGDELIVERY.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGACCEPTANCE && notifications.BUYER_PENDINGACCEPTANCE.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGPAYMENT && notifications.BUYER_PENDINGPAYMENT.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGDELIVERY && notifications.BUYER_PENDINGDELIVERY.count > 0 && setShowGreenDot(true);
  };
  useEffect(function () {
    notifications && hasNotifications(notifications);
  }, [notifications]);
  return /*#__PURE__*/React.createElement(ContainerHamburger, {
    isActive: isActive
  }, showGreenDot ? /*#__PURE__*/React.createElement(GreenDot, {
    className: isActive ? 'is-active' : ''
  }) : null, isActive ? /*#__PURE__*/React.createElement(Iclose, {
    fill: "gray9",
    onClick: function onClick(e) {
      return _onClick(e);
    }
  }) : /*#__PURE__*/React.createElement(IhamburgerMenu, {
    fill: "gray9",
    onClick: function onClick(e) {
      return _onClick(e);
    }
  }));
});
AgroHamburgerButton.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  notifications: PropTypes.object
};
var ContainerHamburger = styled.div.withConfig({
  displayName: "AgroHamburgerButton__ContainerHamburger",
  componentId: "sc-1lgtp04-0"
})(["display:flex;justify-content:center;align-items:center;position:relative;box-sizing:border-box;margin:", ";"], function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? '12px 8px 12px 24px' : '12px 8px 12px 16px';
});
var GreenDot = styled.span.withConfig({
  displayName: "AgroHamburgerButton__GreenDot",
  componentId: "sc-1lgtp04-1"
})(["position:absolute;top:-4px;left:12px;background-color:", ";width:8px;height:8px;border-radius:50px;&.is-active{left:8px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.green500;
});
var AgroHamburgerButtonStyled = styled.button.withConfig({
  displayName: "AgroHamburgerButton__AgroHamburgerButtonStyled",
  componentId: "sc-1lgtp04-2"
})(["border:none;background:transparent;border-radius:0;transition:background-color 0s;z-index:9;padding:0;&:active,&:focus{outline:0;}.icon-bar{display:flex;width:24px;height:3px;border-radius:50px;transition:all 0.2s ease;background:", ";&:nth-of-type(1){transform:rotate(0);margin:0px 0px 4px 0px;}&:nth-of-type(2){opacity:1;filter:alpha(opacity=100);margin:4px 0px 4px 0px;}&:nth-of-type(3){transform:rotate(0);margin:4px 0px 0px 0px;}}&.is-active{.icon-bar{width:17px;&:nth-of-type(1){transform:rotate(45deg);}&:nth-of-type(2){opacity:0;filter:alpha(opacity=0);}&:nth-of-type(3){transform:rotate(-45deg);}}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.gray900;
});
AgroHamburgerButton.displayName = 'AgroHamburgerButton';
export { AgroHamburgerButton };